import { combineReducers } from 'redux';

import auth from './auth';
import breadcrumbs from './breadcrumbs';
import customer from './customer';
import defaultSelections from './defaultSelections';
import downDistance from './downDistance';
import fieldZone from './fieldZone';
import grid from './grid';
import groups from './groups';
import pages from './pages';
import purposes from './purposes';
import sidebar from './sidebar';
import sport from './sport';
import user from './user';
import version from './version';
import filters from './filters';
import settings from './settings';
import navigationSelection from './navigationSelection';
import teams from './teams';
import seasons from './seasons';
import games from './games';
import teamSeasonGameSelection from './teamSeasonGameSelection';

const reducers = combineReducers({
  auth,
  breadcrumbs,
  customer,
  defaultSelections,
  football: combineReducers({
    downDistance,
    fieldZone,
  }),
  grid,
  groups,
  pages,
  purposes,
  sidebar,
  sport,
  user,
  version,
  filters,
  settings,
  navigationSelection,
  teams,
  seasons,
  games,
  teamSeasonGameSelection,
});

export default reducers;
